var map = {
	"./battery.png": "1db0",
	"./cloud.png": "7d7b",
	"./drinks.png": "f115",
	"./food.png": "84e8",
	"./globe.png": "a08b",
	"./medicine.png": "8111",
	"./mood.png": "e652",
	"./mood1.png": "1a6e",
	"./mood2.png": "da58",
	"./mood3.png": "9217",
	"./mood4.png": "31e9",
	"./mood5.png": "b94f",
	"./other.png": "0862",
	"./period.png": "0a03",
	"./runner.png": "465a",
	"./sleep.png": "3084",
	"./toilet.png": "58da",
	"./vitamins.png": "ea9b",
	"./warning.png": "f8cb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5b48";